import { render, staticRenderFns } from "./SettingsTabSidebar.vue?vue&type=template&id=a4e7cfca&scoped=true&"
import script from "./SettingsTabSidebar.vue?vue&type=script&lang=js&"
export * from "./SettingsTabSidebar.vue?vue&type=script&lang=js&"
import style0 from "./SettingsTabSidebar.vue?vue&type=style&index=0&id=a4e7cfca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4e7cfca",
  null
  
)

export default component.exports